<template>
  <div class="smartphone-calendar">

    <transition name="fade">
      <div class="eev-sticky-event" v-if="stickyEvent" :style="{'backgroundImage': 'url(' + visuelSticky.url + ')'}">
        <div class="encart-categorie"
          v-if="
            stickyEvent.category_event[0] &&
            eventsCategories[stickyEvent.category_event[0]] &&
            eventsCategories[stickyEvent.category_event[0]].color
          "
          :style="{'background-color': eventsCategories[stickyEvent.category_event[0]].color}"
        >
          {{eventsCategories[stickyEvent.category_event[0]].name}}
        </div>
        <div class="encart-infos">
          <h2>{{stickyEvent.name}}</h2>
          <div class="infos-time">{{displayEventDate(stickyEvent)}}</div>
          <div class="infos-time" v-if="hasEventTime(stickyEvent)">{{displayEventDate(stickyEvent)}}</div>
          <div class="infos-lieu" v-if="stickyEvent.lieu">{{stickyEvent.lieu}}</div>
          <div class="event-link" v-if="stickyEvent.lien">
            <a v-if="lang === 'fr'" :href="stickyEvent.lien" :style="{'background': stickyEvent.color}" target="_blank">Voir l'événement</a>
            <a v-if="lang === 'en'" :href="stickyEvent.lien" :style="{'background': stickyEvent.color}" target="_blank">Learn more about this event</a>
          </div>
        </div>
      </div>
    </transition>

    <div v-if="displayableEvents && Object.keys(displayableEvents).length">
      <h2 v-if="lang === 'fr'">{{currentMonth.format('MMMM YYYY')}}</h2>
      <h2 v-if="lang === 'en'">{{currentMonth.format('MMMM YYYY')}}</h2>
    </div>

    <div v-if="displayableEvents && Object.keys(displayableEvents).length">
      <div
        v-for="event in displayableEvents"
        :key="event.id"
        :style="{'background':event.color}"
        class="event-smartphone"
        @click.stop="openCard(event)"
      >
        <h2>{{event.name}}</h2>
        <div class="infos-time">{{displayEventDate(event)}}</div>
        <div class="more">
          <i class="fas fa-plus"></i>
        </div>
      </div>
    </div>
    <div v-else-if="!loadingState" class="text-center pl1 pr1 pt2 pb2 no-event-prevu">
      <span v-if="lang === 'fr'">
        Aucun événement n'est prévu pour {{currentMonth.format('MMMM YYYY')}}
      </span>
      <span v-if="lang === 'en'">
        No event is planned in {{currentMonth.format('MMMM YYYY')}}
      </span>
    </div>

    <transition name="fade-quick">
    <div
      class="overlay-selected-event"
      v-if="selectedEvent && Object.keys(selectedEvent).length"
    ></div>
    </transition>

    <transition name="fade-quick">
      <div
        v-if="selectedEvent && Object.keys(selectedEvent).length"
        class="selected-event"
        :style="{'borderColor':selectedEvent.color}"
      >
        <div class="close" @click.stop="closeCard()"><i class="fas fa-times"></i></div>

        <div class="encart-categorie"
          v-if="
            selectedEvent.category_event[0] &&
            eventsCategories[selectedEvent.category_event[0]] &&
            eventsCategories[selectedEvent.category_event[0]].color
          "
          :style="{'background-color': eventsCategories[selectedEvent.category_event[0]].color}"
        >
          {{eventsCategories[selectedEvent.category_event[0]].name}}
        </div>
        <h4 :style="{'color': selectedEvent.color}">{{selectedEvent.name}}</h4>
        <div class="encart-infos">
          <div>
            <div class="picto-calendar">
              <i class="far fa-calendar-alt"></i>
            </div>
            <div>
              {{displayEventDate(selectedEvent)}}
            </div>
          </div>
          <div v-if="hasEventTime(selectedEvent)" class="event-time">
            <div class="picto-calendar">
              <i class="far fa-clock"></i>
            </div>
            <ul>
              <li>{{displayEventTime(selectedEvent)}}</li>
              <li v-if="selectedEvent.horaires">{{selectedEvent.horaires}}</li>
            </ul>
          </div>
          <div v-if="selectedEvent.lieu">
            <div class="picto-calendar">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <div>{{selectedEvent.lieu}}</div>
          </div>
        </div>
        <div class="event-link" v-if="selectedEvent.lien">
          <a v-if="lang === 'fr'" :href="selectedEvent.lien" :style="{'background': selectedEvent.color}" target="_blank">Voir l'événement</a>
          <a v-if="lang === 'en'" :href="selectedEvent.lien" :style="{'background': selectedEvent.color}" target="_blank">Learn more about this event</a>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="nav-mois" v-if="currentMonth">
        <div class="nav_month" @click.stop="prevMonth()">
          <i class="fas fa-chevron-left"></i>
        </div>
        <div class="month"><span>{{currentMonth.format('MMM YYYY')}}</span></div>
        <div class="nav_month" @click.stop="nextMonth()">
          <i class="fas fa-chevron-right"></i>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import Api from '@/api/axios-api.js'
import moment from 'moment'
export default {
  props: {
    eventsCategories: Object,
    lang: String
  },

  data: () => ({
    selectedEvent: {},
    eventsList: {},
    visuelSticky: window.wpApiSettings.visuelSticky,
    currentMonth: moment().startOf('month')
  }),

  mounted () {
    this.fetchData()
  },

  methods: {
    ...mapActions([
      'setLoadingOn',
      'setLoadingOff'
    ]),

    scrollToTop () {
      window.scrollTo(0, 0)
    },

    nextMonth () {
      this.closeCard()
      let newDate = moment(this.currentMonth)
      newDate.add(1, 'months').startOf('month')
      this.currentMonth = newDate
      this.scrollToTop()
    },

    prevMonth () {
      this.closeCard()
      let newDate = moment(this.currentMonth)
      newDate.subtract(1, 'months').startOf('month')
      this.currentMonth = newDate
      this.scrollToTop()
    },

    fetchData () {
      this.setLoadingOn()
      let restURL = window.wpApiSettings.rootFairweb
      let obj = this
      Api.get(restURL + 'events/' + this.lang).then(function (response) {
        let data = response.data
        if (data.liste) {
          obj.eventsList = data.liste
          obj.setLoadingOff()
        }
      })
    },

    openCard (event) {
      this.selectedEvent = event
    },

    closeCard () {
      this.selectedEvent = null
    },

    displayEventDate (eventInfos) {
      let duree = eventInfos.duree
      let displayDate
      let format
      if (this.lang === 'fr') {
        format = 'dddd Do MMMM YYYY'
      }
      if (this.lang === 'en') {
        format = 'dddd MMMM D YYYY'
      }

      if (duree === 'journee') {
        displayDate = moment(eventInfos.date_debut).format(format)
      } else {
        if (this.lang === 'fr') {
          displayDate = 'Du ' + moment(eventInfos.date_debut).format(format) + ' au ' + moment(eventInfos.date_fin).format(format)
        }
        if (this.lang === 'en') {
          displayDate = 'From ' + moment(eventInfos.date_debut).format(format) + ' to ' + moment(eventInfos.date_fin).format(format)
        }
      }
      return displayDate
    },

    hasEventTime (eventInfos) {
      if (eventInfos.heure_debut) {
        return true
      }
      return false
    },

    displayEventTime (eventInfos) {
      let displayTime
      let format
      if (this.lang === 'fr') {
        format = 'H[h]mm'
      }
      if (this.lang === 'en') {
        format = 'h:mm A'
      }
      displayTime = moment('1980-09-18 ' + eventInfos.heure_debut).format(format)
      if (eventInfos.heure_fin) {
        displayTime += ' - ' + moment('1980-09-18 ' + eventInfos.heure_fin).format(format)
      }
      return displayTime
    }

  },
  computed: {
    ...mapGetters([
      'loadingState'
    ]),

    stickyEvent: function () {
      if (!this.eventsList || !Object.keys(this.eventsList).length) {
        return null
      }
      let arrSticky = null
      Object.keys(this.eventsList).forEach(key => {
        if (this.eventsList[key].sticky_post) {
          arrSticky = this.eventsList[key]
        }
      })
      return arrSticky
    },

    displayableEvents: function () {
      if (!this.eventsList || !Object.keys(this.eventsList).length) {
        return null
      }
      let filteredList = {}
      let debutDumois = this.currentMonth
      let finDuMois = moment(this.currentMonth).endOf('month')
      Object.keys(this.eventsList).forEach(key => {
        let debut = moment(this.eventsList[key].date_debut)
        let fin = moment(this.eventsList[key].date_fin)
        if (
          (debut >= debutDumois && debut <= finDuMois) ||
          (fin >= debutDumois && fin <= finDuMois)
        ) {
          filteredList[key] = this.eventsList[key]
        }
      })

      let sortedList = _.orderBy(filteredList, 'date_debut')

      return sortedList
    }
  }
}
</script>
<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .fade-quick-enter-active, .fade-quick-leave-active {
    transition: opacity 0.5s;
  }
  .fade-quick-enter, .fade-quick-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  #elnna_col_content{
    min-height: 0;
  }

  #eev-calendar{
    background: none;
    padding:0.5rem;
    border-radius: 0;
    width:100vw !important;
    margin-bottom: 3rem;
  }

  #elnna_col_content{
    padding: 0;
  }

  body.archive.has-calendar h1.entry-title{
    margin-bottom:1.5rem;
  }

  .smartphone-calendar .nav-mois{
    position:fixed;
    bottom:0;
    left:0;
    z-index:100;
    width: 100vw;
    display: flex;
    background:#FFF;
    align-items: center;
    justify-content: center;
    background: var(--couleur1);
    color:#FFF;
    border-top:1px solid rgba(255,255,255,0.2);
    box-shadow: 0px -3px 4px rgba(0,0,0,0.3);
  }

  .smartphone-calendar .nav-mois > *{
    flex:1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .smartphone-calendar .nav-mois > .month{
    font-size: 1.3rem;
    font-weight: 600;
  }

  .smartphone-calendar .nav-mois > .month span::first-letter{
    text-transform: uppercase;
  }

  .smartphone-calendar .nav-mois > .nav_month{
    font-size: 1.6rem;
    padding:1rem 0;
    cursor: pointer;
    color:#FFF;
  }

  .smartphone-calendar .nav-mois > .nav_month:active{
    background:rgba(255,255,255,0.5);
    color:#FFF;
  }

  .event-smartphone{
    color:#FFF;
    padding:0.5rem 0.75rem;
    border-radius: 10px;
    position: relative;
  }

  .event-smartphone + .event-smartphone{
    margin-top: 0.8rem;
  }

  .event-smartphone h2{
    font-size: 1.5rem;
  }

  .event-smartphone h2:first-letter{
    text-transform: uppercase;
  }

  .event-smartphone .infos-time{
    padding-right: 10vw;
  }

  .event-smartphone .more{
    position: absolute;
    bottom: 0;
    right: 0.25rem;
  }

  .event-smartphone:active{
    opacity: 0.5;
    transform: translate(1px,1px);
  }

  .overlay-selected-event{
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    background:rgba(255,255,255,0.8);
    z-index: 99;
  }

  .selected-event{
    position: fixed;
    z-index: 100;
    left: 1rem;
    top: calc(50px + 1rem);
    border:3px solid #000;
    bottom: calc(57px + 1rem);
    right: 1rem;
    background:#FFF;
    border-radius: 10px;
  }

  .selected-event .close{
    position: absolute;
    right: 0.4rem;
    top: 0.2rem;
    padding:0.5rem;
    color: #FFF;
    font-size: 1.9rem;
    opacity: 1;
  }

  .selected-event .close:active{
    color:rgba(0,0,0,0.5);
  }

  .selected-event .encart-categorie{
    color:#FFF;
    font-size: 1.2rem;
    text-transform: uppercase;
    font-family: 'FjallaOne';
    padding:0.8rem 1rem;
  }

  .selected-event h4{
    padding:1rem;
    font-size: 1.8rem;
    font-family: 'NotoSans';
    margin-bottom: 1rem;
    letter-spacing: -0.4px;
  }

  .selected-event .encart-infos{
    padding:0 1rem 1rem 1rem;
    display: flex;
    flex-direction: column;
  }

  .selected-event .encart-infos > div{
    display: flex;
  }

  .selected-event .event-time ul{
    padding: 0;
    margin: 0;
  }

  .selected-event .event-time li{
    list-style-type: none;
  }

  .selected-event .encart-infos > div + div{
    margin-top: 1rem;
  }

  .selected-event .encart-infos .picto-calendar{
    font-size: 1.8rem;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .selected-event .event-link{
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    display: flex;
  }

  .selected-event .event-link a{
    display: block;
    width: 100%;
    text-align: center;
    color:#FFF;
    font-size: 1.4rem;
    font-family: 'FjallaOne';
    border-radius: 99em;
    padding:0.7rem 1rem;
  }

  .eev-sticky-event{
    display: flex;
    flex-direction: column;
    margin:1rem 0 2rem 0;
    background-size: cover;
    background-position: center;
  }

  .eev-sticky-event .encart-categorie{
    color:#FFF;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-family: 'FjallaOne';
    font-size: 1.4rem;
    line-height: 1.5rem;
    padding: 0.5rem;
  }

  .eev-sticky-event .encart-infos{
    background:rgba(0,0,0,0.25);
    color:#FFF;
    flex:1;
    padding:1rem 1.7rem;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    font-family: 'NotoSans';
  }

  .eev-sticky-event .encart-infos h2{
    font-family: 'NotoSans';
    font-weight: 600;
    font-size: 1.9rem;
    margin-bottom: 0.2rem;
  }

  .eev-sticky-event .encart-infos .infos-time{
    font-size: 1.2rem;
    font-weight: 100;
  }

  .eev-sticky-event .encart-infos .infos-lieu{
    font-size: 1.1rem;
    font-weight: 100;
    margin-top: 0.25rem;
  }

  .eev-sticky-event .encart-infos h2::first-letter{
    text-transform: uppercase;
  }

  .eev-sticky-event .event-link{
    margin-top: 0.9rem;
  }

  .eev-sticky-event .event-link a{
    display: inline-block;
    padding:0.5rem 2rem;
    color:#FFF;
    font-family: 'FjallaOne';
    font-size: 1.1rem;
    border-radius: 99em;
    border:1px solid #FFF;
    box-shadow: 0px 0px 0px rgba(0,0,0,0.3);
  }

  .eev-sticky-event .event-link a:hover{
    transform: scale(1.05);
    box-shadow: 4px 4px 4px rgba(0,0,0,0.3);
  }

  .no-event-prevu{
    border: 1px solid rgba(0,0,0,0.5);
    width: 80vw;
    border-radius: 10px;
    margin:1rem auto 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/smartphoneCalendar.vue